<template>
  <div id="sitemap">
    <div class="body gutter-lg mb">
    <h1 class="sitemaptitle">Site Map</h1>
    <h2>Homepage</h2>
    <p><router-link to="/" aria-label="Link to Sitemap">Welcome</router-link></p>
    <h2>Academics</h2>
    <ul>
        <li><router-link to="/academics/overview" aria-label="Overview">Overview</router-link></li>
        <li><router-link to="/academics/undergraduate-business" aria-label="Undergraduate Business Administration">Undergraduate Business Administration</router-link></li>
        <li><router-link to="/academics/world-bachelor-business" aria-label="World Bachelor in Business">World Bachelor in Business</router-link></li>
        <li><router-link to="/academics/undergraduate-accounting" aria-label="Undergraduate Accounting">Undergraduate Accounting</router-link></li>
        <li><router-link to="/academics/business-cinematic-arts" aria-label="Business Cinematic Arts">Business Cinematic Arts</router-link></li>
        <li><router-link to="/academics/realestate" aria-label="Real Estate Finance + Development (REFD)">Real Estate Finance + Development (REFD)</router-link></li>
        <li><router-link to="/academics/artificial-intelligence-for-business" aria-label="Artificial Intelligence for Business">Artificial Intelligence for Business</router-link></li>
        <li><router-link to="/academics/double-majors-minors" aria-label="Double Majors and Minors">Double Majors and Minors</router-link></li>
        <li><router-link to="/academics/electives" aria-label="Electives">Electives</router-link></li>
    </ul>
    <h2>Advantages</h2>
    <ul>
        <li><router-link to="/advantages/experiential-learning" aria-label="Experiential Learning">Experiential Learning</router-link></li>
        <li><router-link to="/advantages/global-opportunities" aria-label="Global Opportunities">Global Opportunities</router-link></li>
        <li><router-link to="/advantages/careers-internships" aria-label="Internships and Career Services">Internships and Career Services</router-link></li>
        <li><router-link to="/advantages/thematic-option-program-and-scholar-distinctions" aria-label="Scholar Distinction">Scholar Distinction</router-link></li>
        <li><router-link to="/advantages/faculty" aria-label="Faculty">Faculty</router-link></li>
        <li><router-link to="/advantages/visiting-speakers" aria-label="Visiting Speakers">Visiting Speakers</router-link></li>
        <li><router-link to="/advantages/la-advantages" aria-label="L.A. Advantages">L.A. Advantages</router-link></li>
    </ul>
    <h2>Campus Life</h2>
    <ul>
        <li><router-link to="/campus-life/student-organizations" aria-label="Student Organizations">Student Organizations</router-link></li>
        <li><router-link to="/campus-life/community-involvement" aria-label="Community Engagement">Community Engagement</router-link></li>
        <li><router-link to="/campus-life/recreational-sports" aria-label="Recreational Sports">Recreational Sports</router-link></li>
        <li><router-link to="/campus-life/enjoying-la" aria-label="Enjoying Los Angeles">Enjoying Los Angeles</router-link></li>
        <li><router-link to="/campus-life/facilities" aria-label="Facilities">Facilities</router-link></li>
        <li><router-link to="/campus-life/usc-housing" aria-label="USC Housing">USC Housing</router-link></li>
        <li><router-link to="/campus-life/transportation" aria-label="Transportation">Transportation</router-link></li>
    </ul>
    <h2>Next Step</h2>
    <p><router-link to="/next-steps" aria-label="Next Steps">Next Steps</router-link></p>
    <h2>Resources</h2>
    <ul>
        <li><router-link to="/resources/marshall-undergraduate-programs" aria-label="Marshall Undergraduate Programs">Marshall Undergraduate Programs</router-link></li>
        <li><router-link to="/resources/usc-admissions-finaid-students-accounts" aria-label="USC Admissions, Financial Aid and Student Accounts">USC Admissions, Financial Aid and Student Accounts</router-link></li>
        <li><router-link to="/resources/housing-transportation" aria-label="Housing and Transportation">Housing and Transportation</router-link></li>
        <li><router-link to="/resources/international-students" aria-label="International Students">International Students</router-link></li>
        <li><router-link to="/resources/orientation-and-tours" aria-label="Orientation and Tours">Orientation and Tours</router-link></li>
        <li><router-link to="/resources/academic-resources" aria-label="Academic Resources">Academic Resources</router-link></li>
        <li><router-link to="/resources/libraries" aria-label="Libraries">Libraries</router-link></li>
        <li><router-link to="/resources/administrative-services" aria-label="Administrative Services">Administrative Services</router-link></li>
        <li><router-link to="/resources/wellness-safety" aria-label="Wellness and Safety">Wellness and Safety</router-link></li>
        <li><router-link to="/resources/student-organizations" aria-label="Student Organizations and Affinity Groups">Student Organizations and Affinity Groups</router-link></li>
        <li><router-link to="/resources/athletics-recreation" aria-label="Athletics and Recreations">Athletics and Recreations</router-link></li>
    </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sitemap'
}
</script>

<style scoped lang="scss">
.sitemaptitle{
    padding: 25px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/SiteMap.vue